import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import './css/triviaPanel.css';
import baseUrl from './constants/config'

class ReportModal extends Component {
  
  constructor (props) {
    super(props)
    this.onOpenModal = this.onOpenModal.bind(this)
    this.onCloseModal = this.onCloseModal.bind(this)
    this.onReportProblem = this.onReportProblem.bind(this)
    this.state = {
      open: false,
      inputValue: ''
    }
  }

  onOpenModal() {
    this.setState({ open: true });
    this.props.openAction()
  };

  isOpen() {
    return this.state.open;
  }
 
  onCloseModal() {
    this.setState({ open: false });
  };

  onReportProblem(event) {
    event.preventDefault()
    this.setState({ open: false });
    if (this.state.inputValue === "") {
      return
    }
    fetch(baseUrl + 'trivia/api/reportProblem', { 
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          roomId: this.props.roomId,
          userId: this.props.userId,
          problemDescription: this.state.inputValue
        })
      })
      .then(response => response.json())
      .then(data => {
      });
  }

  updateInputValue(evt) {
    this.setState({
      inputValue: evt.target.value
    });
  }

  render() {
    return (
      <div>
        <button onClick={this.onOpenModal} className="questionControlButton">Report this</button>
        <Modal open={this.state.open} onClose={this.onCloseModal} center>
          <h2>Report a problem</h2>
          <h5>Leave your email if you want to be notified of any updates to the problem.</h5>
          <form className="commentForm" onSubmit={this.onReportProblem}>
            <textarea 
              rows="4"
              cols="50"
              type="text" 
              placeholder = "Description of the problem" 
              className = "Text-Input"
              value={this.state.inputValue}
              onChange={evt => this.updateInputValue(evt)}
              ref={input => input && input.focus()} />
            <button className="Answer-Submit-Btn" type = "submit" onClick={this.onCloseModal} >
              <span>Report</span>
            </button>
          </form>
        </Modal>
      </div>
    );
  }
}

export default ReportModal;



// WEBPACK FOOTER //
// ./src/components/reportModal.js